var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "mb-5"
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('div', {
    staticClass: "mb-5"
  }, [_vm.error ? _c('div', {
    staticClass: "alert alert-danger mt-4"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), !_vm.hasHoldModels ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(" Niets gevonden ")]) : _vm._e(), _vm._l(Object.keys(_vm.holdReasonsPerModelType).sort(), function (holdReasonStatus) {
    return _c('div', {
      key: holdReasonStatus
    }, [holdReasonStatus === 'current' ? _c('h4', {
      staticClass: "mt-4"
    }, [_vm._v(" Nog te reviewen "), _vm._m(0, true)]) : _c('h4', {
      staticClass: "mt-4"
    }, [_vm._v("Gereviewed")]), _vm._l(Object.keys(_vm.holdReasonsPerModelType[holdReasonStatus]).reverse(), function (holdReasonModelType) {
      return _vm.holdReasonsPerModelType[holdReasonStatus][holdReasonModelType].length ? _c('div', {
        key: `${holdReasonStatus}_${holdReasonModelType}`
      }, [!_vm.holdReasonsPerModelType[holdReasonStatus][holdReasonModelType].length && !_vm.error ? _c('div', {
        staticClass: "alert alert-light mt-4"
      }, [_vm._v("Geen")]) : _vm._e(), _vm._l(_vm.groupHoldReasonsByModelId(_vm.holdReasonsPerModelType[holdReasonStatus][holdReasonModelType]), function (holdReasonsForModel) {
        return _c('b-card', {
          key: holdReasonsForModel[0].id,
          staticClass: "mt-4 mb-2",
          attrs: {
            "no-body": ""
          }
        }, [_c('b-card-header', {
          staticClass: "d-block he-auto p-4"
        }, [_c('hold-reason-model-info-header', {
          attrs: {
            "sales-order": _vm.salesOrder,
            "hold-reasons-for-model": holdReasonsForModel,
            "hold-model-type": holdReasonModelType
          }
        })], 1), _c('div', {
          staticClass: "card-body pb-4"
        }, [_c('div', {
          staticClass: "card-text"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-4 col-md"
        }, [_c('strong', [_vm._v("Reden")])]), _c('div', {
          staticClass: "col-4 col-md"
        }, [_c('strong', [_vm._v("Commentaar")])]), _c('div', {
          staticClass: "col-4 col-md-2 pr-0"
        }, [_c('strong', [_vm._v("Beslissing")])])]), _vm._l(_vm.mapHoldReasons(holdReasonsForModel), function (reason) {
          return _c('form', {
            key: reason.id,
            staticClass: "hold-reasons-list",
            on: {
              "submit": function ($event) {
                $event.preventDefault();
                return _vm.updateReason(reason);
              }
            }
          }, [_c('div', {
            staticClass: "row mt-4",
            attrs: {
              "data-hold-reason-id": reason.id,
              "data-hold-rule-group-id": reason.hold_rule_group_id
            }
          }, [_c('div', {
            staticClass: "col-4 col-md"
          }, [_vm._v(_vm._s(reason.hold_rule_group ? reason.hold_rule_group.display_name : 'Onbekend (niet opgeslagen)'))]), _c('div', {
            staticClass: "col-4 col-md"
          }, [!reason.decision && _vm.hasPermission('orders.holdreview.edit') ? _c('textarea', {
            directives: [{
              name: "model",
              rawName: "v-model.trim",
              value: reason.comment,
              expression: "reason.comment",
              modifiers: {
                "trim": true
              }
            }],
            staticClass: "form-control form-control-sm",
            attrs: {
              "required": "",
              "disabled": _vm.isUpdatingReason
            },
            domProps: {
              "value": reason.comment
            },
            on: {
              "input": function ($event) {
                if ($event.target.composing) return;
                _vm.$set(reason, "comment", $event.target.value.trim());
              },
              "blur": function ($event) {
                return _vm.$forceUpdate();
              }
            }
          }) : _c('span', [_vm._v(_vm._s(reason.comment))])]), !reason.decision ? _c('div', {
            staticClass: "col-4 col-md-2 pr-0 btn-group-sm"
          }, [_vm.isReasonApprovable(reason) ? _c('button', {
            staticClass: "btn border-0 btn-outline-success",
            attrs: {
              "type": "button",
              "title": _vm.thumbsUpTitle,
              "disabled": _vm.thumbsUpDisabled(reason)
            },
            on: {
              "click": function ($event) {
                return _vm.submitReasonForm(reason, _vm.consts.DECISION_STATUS_APPROVED);
              }
            }
          }, [_c('span', {
            staticClass: "fa fa-thumbs-up"
          })]) : _c('button', {
            staticClass: "btn border-0 btn-outline-secondary",
            attrs: {
              "type": "button",
              "title": "Deze reden kan niet vrijgegeven worden. In plaats daarvan kan je de data van de order wijzigen. Hierna wordt de order opnieuw beoordeeld.",
              "disabled": true
            }
          }, [_c('span', {
            staticClass: "fa fa-thumbs-up"
          })]), _c('button', {
            staticClass: "btn btn-outline-danger border-0",
            attrs: {
              "type": "button",
              "title": _vm.thumbsDownTitle,
              "disabled": _vm.thumbsDisabled
            },
            on: {
              "click": function ($event) {
                return _vm.submitReasonForm(reason, _vm.consts.DECISION_STATUS_DENIED);
              }
            }
          }, [_c('span', {
            staticClass: "fa fa-thumbs-down"
          })]), _c('button', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }],
            ref: `form_${reason.id}`,
            refInFor: true,
            attrs: {
              "type": "submit"
            }
          })]) : _c('div', {
            staticClass: "col-4 col-md-2 pr-0 btn-group-sm"
          }, [reason.decision === _vm.consts.DECISION_STATUS_APPROVED ? _c('span', {
            staticClass: "lead text-success",
            attrs: {
              "title": `Deze reden is vrijgegeven op ${_vm.formatDateTime(reason.decision_updated_at)}`
            }
          }, [_c('span', {
            staticClass: "fa fa-thumbs-up"
          })]) : reason.decision === _vm.consts.DECISION_STATUS_DENIED ? _c('span', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip",
              value: `Door deze reden is de blokkering definitief gemaakt op ${_vm.formatDateTime(reason.decision_updated_at)}`,
              expression: "`Door deze reden is de blokkering definitief gemaakt op ${formatDateTime(reason.decision_updated_at)}`"
            }],
            staticClass: "lead text-danger"
          }, [_c('span', {
            staticClass: "fa fa-thumbs-down"
          })]) : reason.decision === _vm.consts.DECISION_STATUS_UNREVIEWABLE ? _c('span', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip",
              value: `Deze reden is niet beoordeeld omdat een andere reden al definitief is geblokkeerd`,
              expression: "`Deze reden is niet beoordeeld omdat een andere reden al definitief is geblokkeerd`"
            }],
            staticClass: "text-secondary"
          }, [_c('span', {
            staticClass: "icon-dash"
          }, [_vm._v("-")])]) : reason.decision === _vm.consts.DECISION_STATUS_INVALIDATED_BY_DATA_CHANGE ? _c('span', {
            directives: [{
              name: "b-tooltip",
              rawName: "v-b-tooltip",
              value: `Deze reden hoeft niet meer te worden beoordeeld omdat de data van de order is gewijzigd. De order wordt opnieuw gecontroleerd a.d.h.v. de nieuwe data.`,
              expression: "`Deze reden hoeft niet meer te worden beoordeeld omdat de data van de order is gewijzigd. De order wordt opnieuw gecontroleerd a.d.h.v. de nieuwe data.`"
            }],
            staticClass: "text-secondary"
          }, [_c('font-awesome-icon', {
            staticClass: "text-secondary",
            attrs: {
              "icon": "ban"
            }
          })], 1) : _vm._e()])])]);
        }), !holdReasonsForModel.length ? _c('div', {
          staticClass: "alert alert-danger mt-4"
        }, [_vm._v(" Deze blokkering heeft geen redenen om te beoordelen. Neem contact op met "), _c('a', {
          attrs: {
            "href": "https://www.omnistock.nl/",
            "target": "_blank"
          }
        }, [_vm._v("OmniStock")]), _vm._v(". ")]) : _vm._e()], 2)])], 1);
      })], 2) : _vm._e();
    })], 2);
  })], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('small', [_c('span', {
    staticClass: "fa fa-info-circle text-info ml-1",
    attrs: {
      "title": "Het kan voorkomen dat volledige gereviewede blokkeringen nog onder dit kopje staan omdat deze nog niet verwerkt zijn door het systeem. Binnen enkele minuten zou dit aangepast moeten zijn na een refresh van de pagina."
    }
  })]);

}]

export { render, staticRenderFns }